import { render } from "./Fotos.vue?vue&type=template&id=30f5ce1f"
import script from "./Fotos.vue?vue&type=script&lang=js"
export * from "./Fotos.vue?vue&type=script&lang=js"

import "./Fotos.vue?vue&type=style&index=0&id=30f5ce1f&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__